import { Box, Container } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import React from 'react'
import { get } from 'lodash'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import LinearProgress from '@material-ui/core/LinearProgress'
import { useQuery } from '@apollo/client'
import AccountDropdown from 'components/account-dropdown'
import Error from 'components/error'
import HelpOutlineIcon from 'components/material-symbol/icons/HelpOutline'
import PGALogo from 'images/pga-logo-navy.png'
import { withProtectedRoute, useAuth, roles } from 'lib/auth'
import { useSupportContactActions } from 'lib/support'
import PgaCoach from './tiles/pga-coach'
import JrLeague from './tiles/jr-league'
import CoachTraining from './tiles/coach-training'
import useStyles from './landing.styles'
import { ProfilesQuery } from './query'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

export function LandingPage() {
  const classes = useStyles()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const { user } = useAuth()
  const { openSupport } = useSupportContactActions()
  const { data, loading, error } = useQuery(ProfilesQuery)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />

  const coachProfile = get(data, 'CoachProfiles.profiles[0]', {})
  const { displayName } = coachProfile
  const welcomeName = (displayName || user.name).trim().split(/\s+/)[0]

  return (
    <Box className={classes.page}>
      <AppBar position="fixed" square className={classes.appBar}>
        <Container>
          <Toolbar>
            <img src={PGALogo} alt="PGA logo" className={classes.logo} />
            <div className={classes.filler} />
            <AccountDropdown />
          </Toolbar>
        </Container>
      </AppBar>

      <Box className={classes.hero}>
        <Container>
          <Box className={classes.heroContent}>
            <Typography className={classes.welcomeBack} component="p">
              Welcome back
            </Typography>
            <Typography component="h1" className={classes.helloName}>
              Hello, {welcomeName}
            </Typography>
            <Typography className={classes.heroSubtext}>
              Choose the experience you&apos;d like to open. You can switch
              between apps anytime from this hub.
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container className={classes.cardsSection}>
        <Grid container justifyContent="center">
          <Grid
            container
            item
            md={10}
            direction="row"
            spacing={isMobile ? 2 : 3}
          >
            <Grid item md={4} sm={6} xs={12}>
              <PgaCoach />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <JrLeague />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CoachTraining />
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item md={10} xs={12}>
            <Box className={classes.helpBanner}>
              <Box className={classes.helpBannerCopy}>
                <HelpOutlineIcon
                  className={classes.helpBannerIcon}
                  fontSize="small"
                  opticalSize={20}
                />
                <Typography component="span" className={classes.helpBannerText}>
                  Need help? Contact our support team for assistance.
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="primary"
                className={classes.helpBannerButton}
                onClick={openSupport}
              >
                Contact support
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default withProtectedRoute(LandingPage, roles.COACH)
